var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"text":""},on:{"click":_vm.clicked}},[_c('v-badge',{attrs:{"content":_vm.counter,"value":_vm.counter,"color":"red lighten-1","overlap":""}},[_c('v-icon',{attrs:{"large":_vm.large}},[_vm._v(_vm._s(_vm.icon))])],1),_c('span',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }